import React from 'react'
import OrgCreateForm from '../../forms/OrgCreateForm'

function OrgAdminCreate() {
  return (
    <div>
        <OrgCreateForm />
    </div>
  )
}

export default OrgAdminCreate